export const LANDING_REGISTER_URL = 'https://beta.lucidbook.com/register/';

export const landingSectionFlags = {
  hero: true,
  storytellers: false,
  evolutionGrid: true,
  languageWorld: true,
  readyToBegin: true,
  communityBooks: false,
  faq: true,
  bottomCta: false,
  footer: true,
} as const;

export const renderDisabledSectionScaffolds = false;
